import ContactMe from "../../Pages/Home/ContactMe";

export default function Contact() {
  return (
    <>
      <ContactMe />
    </>
  );
}
